
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 7">
  <path
    d="M0.102329 1.64555L0.897706 0.850172L5.00002 4.95192L9.10233 0.849609L9.89771 1.64498L5.00002 6.54323L0.102329 1.64555Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ArrowDown',
    }) as DefineComponent
    </script>
    